import React, { useState, useContext } from 'react';
import { LanguageContext } from './LanguageContext';

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const [isOpen, setIsOpen] = useState(false);
  
  const languages = [
    { code: 'pl', name: 'Polski', flag: '/flags/pl.svg' },
    { code: 'en', name: 'English', flag: '/flags/gb.svg' },
    { code: 'fr', name: 'Français', flag: '/flags/fr.svg' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

  const handleLanguageChange = (langCode) => {
    setLanguage(langCode);
    localStorage.setItem('selectedLanguage', langCode);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {/* Current Language Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: window.innerWidth <= 600 ? '4px' : '8px',
          padding: window.innerWidth <= 600 ? '6px 8px' : '8px 12px',
          background: '#e9ecef',
          border: '1px solid #e0e0e0',
          borderRadius: window.innerWidth <= 600 ? '6px' : '8px',
          cursor: 'pointer',
          fontSize: window.innerWidth <= 600 ? '12px' : '14px',
          fontWeight: '500',
          color: '#333',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease',
          minWidth: window.innerWidth <= 600 ? '60px' : '80px',
          justifyContent: 'space-between'
        }}
        onMouseOver={(e) => {
          e.target.style.borderColor = '#7c3aed';
          e.target.style.boxShadow = '0 4px 8px rgba(124, 58, 237, 0.2)';
        }}
        onMouseOut={(e) => {
          e.target.style.borderColor = '#e0e0e0';
          e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
        }}
      >
        <img 
          src={currentLanguage.flag} 
          alt={`${currentLanguage.name} flag`}
          style={{ 
            width: window.innerWidth <= 600 ? '16px' : '20px', 
            height: window.innerWidth <= 600 ? '12px' : '14px',
            objectFit: 'cover',
            borderRadius: '2px'
          }} 
        />
        <span>{currentLanguage.code.toUpperCase()}</span>
        <span style={{ 
          fontSize: window.innerWidth <= 600 ? '10px' : '12px', 
          color: '#666',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease'
        }}>
          ▼
        </span>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: '0',
          background: '#e9ecef',
          border: '1px solid #e0e0e0',
          borderRadius: window.innerWidth <= 600 ? '6px' : '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
          marginTop: '4px',
          overflow: 'hidden',
          minWidth: window.innerWidth <= 600 ? '80px' : '100px'
        }}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: window.innerWidth <= 600 ? '4px' : '8px',
                padding: window.innerWidth <= 600 ? '8px 10px' : '10px 12px',
                background: language === lang.code ? '#f3e5f5' : '#e9ecef',
                border: 'none',
                cursor: 'pointer',
                fontSize: window.innerWidth <= 600 ? '12px' : '14px',
                fontWeight: language === lang.code ? '600' : '400',
                color: language === lang.code ? '#7c3aed' : '#333',
                textAlign: 'left',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                if (language !== lang.code) {
                  e.target.style.background = '#e9ecef';
                }
              }}
              onMouseOut={(e) => {
                if (language !== lang.code) {
                  e.target.style.background = '#e9ecef';
                }
              }}
            >
              <img 
                src={lang.flag} 
                alt={`${lang.name} flag`}
                style={{ 
                  width: window.innerWidth <= 600 ? '16px' : '20px', 
                  height: window.innerWidth <= 600 ? '12px' : '14px',
                  objectFit: 'cover',
                  borderRadius: '2px'
                }} 
              />
              <span>{lang.code.toUpperCase()}</span>
            </button>
          ))}
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default LanguageSelector;
